module.exports = __webpack_public_path__ + "static/hv-corner-2ddba7ce0ac3481948b286bd7bc967f8.svg";